<template>
    <div class="business">
        <menuBox :step="2"></menuBox>
        <div class="about-title">核心業務</div>
        <div class="business-box">
            <div class="business-img-text">
                <img src="../assets/img-7.png">
                <div class="text text-l">
                    <div class="text-title">安全、完整的系統策劃和設計：</div>
                    <!-- <p>本公司堅決做好新形勢下的人才隊伍建設，上下齊動手，擁有成熟可靠、經驗豐富的技術服務團隊，擁有健全的公司管理標準，擁有國際領先技術水平、優質的投放環境、以更高的效率和效能可觸達市場，包括程序化投放廣告平台bitpanda，智能投放系統mediabuy，移動數據分析平台DMP。 </p> -->
                    <p>本公司堅決做好新形勢下的人才隊伍建設，上下齊動手，擁有成熟可靠、經驗豐富的技術服務團隊，擁有健全的公司管理標準，擁有國際領先技術水平、優質的投放環境、以更高的效率和效能可觸達市場，智能投放系統mediabuy，移動數據分析平台DMP。 </p>
                </div>
            </div>

            <div class="business-img-text">
                <div class="text text-r">
                    <div class="text-title">先進、可靠的服務器安全保障服務：</div>
                    <p>由從業資深經驗的印尼市場專家帶隊，成為行業領先的本土化支付方案解決供應商，協助商戶對接各大持牌機構的一系列支付服務，實行科技，遊戲，直播等多個場景使用，為出海公司支付安全提供了強有力的保障。 </p>
                </div>
                <img src="../assets/img-8.png">
            </div>

            <div class="business-img-text">
                <img src="../assets/img-9.png">
                <div class="text text-l">
                    <div class="text-title">完善、先進的研發理念：</div>
                    <p>牢固樹立整個公司“一盤棋”的工作理念，從而在“堅持一個目標、狠抓大事”的目標指引下，以“有守有為、敢於擔當、改革創新、虛工實做、奮發有為”的新行動新舉措，不斷開創各項工作的新局面。 </p>
                </div>
            </div>
            <!-- <p>作為一家專注海外數字營銷解決方案的綜合服務企業， 為遊戲、APP、電商、品牌四大品類的中國企業提供跨境數字營銷服務， 通過自主研發的技術賦能平台和數據可視化分析系統，幫助用戶快速實現跨平台出海營銷策略和決策制定，為每個出海企業提供可定制化的、高品質的創意服務。 </p>
            <p>隨著越來越多的中國企業出海，為了滿足其更為多元的商業和營銷需求，不斷拓展自己的全球資源，現已成長為一家集合了“本地化服務+全球化網絡”的海外數字營銷綜合服務集團。 </p>
            <p>隨著越來越多的中國企業出海,為滿足更多元的商業和營銷需求, 也在不斷拓展自己的技術與服務能力,深化服務的廣度與深度;未來將繼續升級並優化技術和數據的應用能力,並深化全球產業鏈佈局,整合全球媒介資源,為中國企業打造更為豐富的出海場景全鏈路解決方案。 </p>
            <p>由深諳國際市場環境的資深團隊為國內品牌企業提供海外社交媒體平台的運營管理服務，以國際化視野開拓全球市場，建立並提升本土品牌進入國際市場的全球影響力。 </p> -->

        </div>
        <div class="statr-box">
            <div class="s-text">
                <div class="text-1">使用 FLEUSWORD 開始您的項目</div>
                <div class="text-2">您有計劃嗎？我們有最好的專家，讓我們討論一下</div>
            </div>
            <div class="btn" @click="aboutUs">聯繫我們</div>
        </div>

        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        }
    }
}
</script>
<style lang="less" scoped>
.about-title {
    background-image: url(../assets/about-1.png);
    width: 100%;
    height: 320px;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
    font-weight: 500;
    color: #333333;
}

.business-text {
    padding: 80px 360px 120px 360px;
    font-size: 28px;
    font-weight: 400;
    color: #999999;

    p {
        text-indent: 2em;
        margin-top: 28px;
    }
}

.business-box {
    padding: 0px 360px;
    margin-top: 68px;

    .business-img-text {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 120px;

        img {
            width: 382px;
            height: 318px;
        }

        .text {
            width: 772px;
            font-size: 28px;
            font-weight: 400;
            color: #999999;
            margin-top: 24px;

            .text-title {
                font-size: 40px;
                font-weight: 400;
                color: #333333;
            }

            p {
                margin-top: 24px;
            }
        }

        .text-l {
            margin-left: 47px;
        }

        .text-r {
            margin-right: 47px;
        }
    }
}

.statr-box {
    background: #B043FC;
    padding: 42px 360px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .s-text {
        color: #fff;

        .text-1 {
            font-size: 40px;
            font-weight: 400;
            color: #FFFFFF;
        }

        .text-2 {
            font-size: 24px;
            font-weight: 400;
            color: #FFFFFF;
        }
    }

    .btn {
        cursor: pointer;
        width: 160px;
        height: 64px;
        background: #FFFFFF;
        border-radius: 8px;
        line-height: 64px;
        font-size: 24px;
        text-align: center;
        font-weight: 400;
        color: #B043FC;
    }
}
</style>
